import { Component, inject, Injector, OnInit } from '@angular/core';
import { Database, get, ref, remove, set } from "@angular/fire/database";
import { AuthService } from 'src/app/services/auth.service';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-performancedetail',
  templateUrl: './performancedetail.component.html',
  styleUrls: ['./performancedetail.component.css']
})
export class PerformancedetailComponent extends BaseComponent implements OnInit {
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  player: any = {}
  scenarioId: string | null = null
  showRawData = false
  showComponentDownload = false
  showInteractivities = false
  totalComponentFileSize = 0
  totalCycleLoadTime = 0
  ipLocation: any = null

  constructor(injector: Injector, private authService: AuthService) {
    super(injector)
  }
  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = await this.authService.initializeAuth(() => this.onSuccessfullLogin())
  }

  async signInWithGoogle() {
    this.isAuthenticatedWithFirebase = await this.authService.signInWithGoogle()
    if (this.isAuthenticatedWithFirebase) { await this.onSuccessfullLogin() }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }
  getData = async () => {
    const exerciseId = this.getQueryParameter('exerciseid')
    const playername = this.getQueryParameter('playername')
    this.totalComponentFileSize = 0

    this.loader.show()
    const refe = ref(this.database, 'performance/' + exerciseId + '/' + playername);
    const snapshot = await get(refe);
    if (snapshot.exists()) {
      this.player = snapshot.val();
      if (this.player.loadComponents) {
        this.player.loadComponents.formattedDetails.forEach((element: any) => {
          if (element.FileSizeKB) {
            this.totalComponentFileSize += element.FileSizeKB
          }
        });
      }
      // Try to get scenarioId from player record first
      this.scenarioId = this.player.scenarioId || this.player.scenarioid || null
    }
    // If scenarioId not in player record, fetch related exercise under /exercises/<exerciseId>
    if (!this.scenarioId) {
      const exerciseRef = ref(this.database, 'exercises/' + exerciseId);
      const exerSnap = await get(exerciseRef);
      if (exerSnap.exists()) {
        const exerVal = exerSnap.val();
        this.scenarioId = exerVal.scenarioId || exerVal.scenarioid || null
      }
    }
    // calculate performance on CPU
    this.totalCycleLoadTime = 0
    if (this.player.render && this.player.babylonRender) {
      const fps = this.player.render.fps*1.0
      const updateDuration = this.player.render.durationFor100CallsMs * 1.0
      const renderDuration = this.player.babylonRender.averageRenderTime * 1.0
      this.totalCycleLoadTime = (renderDuration + updateDuration / 100) * fps
    }
    this.ipLocation = {city: "Unknown", country: "Unknown", region: "Unknown"}
    if (this.player.ip) {
        this.ipLocation = await this.getIpLocation(this.player.ip);
    }

    this.loader.hide()
  }

  async getIpLocation(ip: string): Promise<void> {
    const response = await fetch(`https://ipapi.co/${ip}/json/`);
    const data = await response.json();
    return data
  }
  
  back() {
    this.router.navigate(['performance'])
  }
  async refresh() {
    this.loader.show()
    await this.getData()
    this.loader.hide()
  }
}
